import * as React from 'react'
import cn from 'classnames'
import styles from './spinner.module.scss'

interface ISpinnerProps {
  variant?: 'brand' | 'white' | 'dark' | 'success' | 'free' | 'bankId'
  className?: string
  style?: React.CSSProperties
}

export default function Spinner(props: ISpinnerProps) {
  const colors = {
    brand: '#ff0099',
    white: '#ffffff',
    dark: '#000000',
    success: '#3ed059',
    free: '#ffff00',
    bankId: '#459bbe',
  }

  return (
    <div className={cn(styles.root, props.className)} style={props.style}>
      <i>
        <svg viewBox="0 0 50 50">
          <circle
            cx="25"
            cy="25"
            fill="none"
            r="20"
            stroke={props.variant ? colors[props.variant] : '#308dfb'}
            strokeWidth="5"
          />
        </svg>
      </i>
    </div>
  )
}
